<div
  style="
    background-image: url('assets/images/dashboard/login.avif');
    height: 100vh;
  "
>
  <div
    class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
    style="display: flex; height: 100vh"
  >
    <div
      class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
      class="planDivSub"
      style="
        display: grid;
        width: 1048px;
        margin: auto;
        background-color: white;
        border-radius: 18px;
      "
    >
      <div style="color: #474747; text-align: left; margin-left: 20px">
        <em
          (keydown)="showTemplateSignUp()"
          (click)="showTemplateSignUp()"
          style="float: right; margin: 20px"
          class="fa fa-window-close closeAttach"
          aria-hidden="true"
        ></em>
        <h3 style="font-weight: bold">
          {{ 'selfPlans.planTitle' | translate }}
        </h3>
        <h5 style="font-style: work sans">
          {{ 'selfPlans.subTitle' | translate }}
        </h5>
      </div>
      <div
        style="
          color: black;
          text-align: left;
          margin-top: 15px;
          margin-left: 20px;
          font-weight: bold;
        "
      >
        <div style="font-size: 16px">You have a 14-day trial period</div>
      </div>
      <div class="form-group planLabel">
        <div *ngFor="let item of planList" class="planDiv">
          <div style="min-height: 313px">
            <h5 style="font-weight: bold; color: black; font-size: 16px">
              {{ item.name }}
            </h5>
            <h5 style="color: black; font-size: 16px">{{ item.price }}</h5>
            <div class="subTab" *ngIf="item.details?.mau">
              <em class="fa-solid fa-check"></em>
              <span
                >{{ item.details.mau }} {{ 'selfPlans.mau' | translate }}</span
              >
            </div>
            <div *ngFor="let tab of item.tabs">
              <div class="subTab">
                <em class="fa-solid fa-check"></em>
                <span *ngIf="tab?.name">{{ tab.name }}</span>
                <span *ngIf="tab?.info">{{ tab.info }}</span>
              </div>
            </div>
            <h5 style="font-weight: bold" *ngIf="!item['priceId']">
              {{ 'selfPlans.contact_us' | translate }}
            </h5>
          </div>
        </div>
      </div>
      <div
        *ngIf="planList?.length"
        class="login-input"
        style="text-align: center"
      >
        <button
          id="choosePlan"
          class="btn-default btn-auth loginBtn postionbutton"
          type="submit"
          (click)="showTemplateSignUp()"
        >
          {{ 'selfService.signUp' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="page-loader" *ngIf="loadershow">
  <img
    alt=""
    src="assets/images/dashboard/uib-loading-500x500.gif"
    style="width: 100px"
  />
</div>
